import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/AboutPage.css";
import { motion } from "framer-motion";

export default function AboutPage() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [aboutContent, setAboutContent] = useState(null);
  const [loading, setLoading] = useState(true);

  // Reusable animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  // Page loader
  const PageLoader = () => {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#ffffff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
        />
        <p className="mt-3 fw-semibold">Loading About Porvaall...</p>
      </div>
    );
  };


  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}aboutus_content_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });

        const data = await res.json();
        console.log("About Us Content:", data);

        if (data?.head?.code === 200 && data.body.length > 0) {
          setAboutContent(data.body[0].content);
        } else {
          setAboutContent(null);
        }
      } catch (err) {
        console.error("Failed to fetch About Us content:", err);
        setAboutContent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutContent();
  }, [API_BASE_URL]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const adsRef = useRef(null);

  const scrollAds = (direction) => {
    if (!adsRef.current) return;
    const total = ads.length;
    let nextIndex = currentIndex + direction;

    if (nextIndex < 0) nextIndex = total - 1;
    if (nextIndex >= total) nextIndex = 0;

    const width = adsRef.current.offsetWidth;
    adsRef.current.scrollTo({
      left: width * nextIndex,
      behavior: "smooth",
    });

    setCurrentIndex(nextIndex);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      scrollAds(1);
    }, 3000); // every 3 seconds
    return () => clearInterval(interval);
  }, [currentIndex]);
  const [ads, setAds] = useState([]);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}aboutbanner_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.head.code === 200 && data.body.length > 0) {
          // Sort by rank if needed
          const sortedAds = data.body.sort(
            (a, b) => a.adsbanner_rank - b.adsbanner_rank,
          );
          const adsUrls = sortedAds.map((ad) => ad.adsbanner_url);
          setAds(adsUrls);
        } else {
          console.log("No ads found");
        }
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    };

    fetchAds();
  }, [API_BASE_URL]);


  return (
    <>
      {loading && <PageLoader />}
      <div className="about-page">

        {/* 🌟 HERO SECTION */}
        <motion.section
          className="text-center d-flex align-items-center justify-content-center"
          style={{ minHeight: "20vh", background: "#0b2747", color: "white", padding: "30px 20px" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <div className="container">
            <motion.h1
              className="display-4 fw-bold"
              initial={{ y: -50 }}
              animate={{ y: 0 }}
              transition={{ duration: 1 }}
            >
              About Porvaall
            </motion.h1>

            <motion.p
              className="lead mt-3"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 1 }}
            >
              Inspiring knowledge. Empowering minds. Connecting ideas.
            </motion.p>
          </div>
        </motion.section>

        {/* 🌟 ABOUT CONTENT FROM DATABASE */}
        <motion.section
          className="container py-4"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeUp}
        >
          {loading ? (
            <p className="text-center">Loading content...</p>
          ) : aboutContent ? (
            <div
              className="text-dark"
              dangerouslySetInnerHTML={{ __html: aboutContent }}
            />
          ) : (
            <p className="text-center text-danger">No About Us content available.</p>
          )}
        </motion.section>

        <div className="ads-wrapper">
          {/* Left Arrow */}
          <button
            className="ads-arrow left"
            onClick={() => scrollAds(-1)}
          >
            ‹
          </button>

          {/* Scroll Container */}
          <div className="ads-scroll" ref={adsRef}>
            {ads.map((img, index) => (
              <div key={index} className="ads-item">
                {/* <a href="https://sdspc.in/" target="_blank" rel="noopener noreferrer"> */}
                  <img src={img} alt={`Ad ${index}`} />
                {/* </a> */}
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <button
            className="ads-arrow right"
            onClick={() => scrollAds(1)}
          >
            ›
          </button>
        </div>
        <br />

      </div>
    </>
  );
}
